import { useState } from "react";
import styled from "styled-components";

import Spacing from "@vfuk/core-spacing";

import arrowNone from "./../assets/svg/sort-disabled.svg";
import arrowDown from "./../assets/svg/sort-down.svg";
import arrowUp from "./../assets/svg/sort-up.svg";
import { SortDirection } from "./types";

type TableHeaderArrowsProps = {
  alwaysVisible?: boolean;
  defaultDirection?: SortDirection;
  onClick: (arg: SortDirection) => void;
};

const IconDiv = styled.div<{ isVisible: boolean }>`
  margin-top: 5px;
`;

const StyledIconImage = styled.img`
  width: 24px;
  height: 24px;
  vertical-align: unset;
  max-width: unset;
  cursor: pointer;
`;

export const TableHeaderArrows = ({
  alwaysVisible = true,
  defaultDirection = SortDirection.NONE,
  onClick,
}: TableHeaderArrowsProps) => {
  const [direction, setDirection] = useState(defaultDirection);
  const [isArrowVisible, setArrowVisible] = useState(
    alwaysVisible || defaultDirection !== SortDirection.NONE
  );
  const onHover = () => setArrowVisible(true);
  const onLeave = () => setArrowVisible(false);

  return (
    <IconDiv
      onMouseOver={onHover}
      onMouseOut={onLeave}
      isVisible={alwaysVisible || isArrowVisible}
    >
      <Spacing spacingLevel={{ left: 1, right: 3 }}>
        {!alwaysVisible && (
          <StyledIconImage
            src={arrowNone}
            onClick={() => {
              setDirection(SortDirection.DESC);
              onClick(SortDirection.DESC);
            }}
          />
        )}
        {alwaysVisible && direction === SortDirection.DESC && (
          <StyledIconImage
            src={arrowUp}
            onClick={() => {
              setDirection(SortDirection.ASC);
              onClick(SortDirection.ASC);
            }}
          />
        )}
        {alwaysVisible && direction === SortDirection.ASC && (
          <StyledIconImage
            src={arrowDown}
            onClick={() => {
              setDirection(SortDirection.DESC);
              onClick(SortDirection.DESC);
            }}
          />
        )}
      </Spacing>
    </IconDiv>
  );
};
